export const SET_SUB_MENU_DIRECTION = 'SET_SUB_MENU_DIRECTION';

export type MenuDirectionType = 'HORIZONTAL' | 'VERTICAL';
export type MenuDirectionState = MenuDirectionType;

export interface SetSubMenuDirectionAction {
  type: typeof SET_SUB_MENU_DIRECTION;
  subMenuDirection: MenuDirectionType;
}
